document.addEventListener("DOMContentLoaded", () => {
  const videoContainers = document.querySelectorAll(".video-container");

  videoContainers.forEach(container => {
    const video = container.querySelector("video");
    const playButton = container.querySelector(".play-button");
    const arrow = document.getElementById("arrow-indicator");
    let arrowTimeout;

    if (!video || !playButton) return;

    // Funkce pro zastavení všech ostatních videí
    const stopAllOtherVideos = (currentVideo) => {
      document.querySelectorAll("video").forEach(v => {
        if (v !== currentVideo) {
          v.pause();
          v.closest(".video-container")?.querySelector(".play-button")?.classList.remove("hidden");
        }
      });
    };

    playButton.addEventListener("click", () => {
      stopAllOtherVideos(video); // Zastav ostatní
      video.play();
      playButton.classList.add("hidden");
      video.muted = false;
    });

    video.addEventListener("click", () => {
      if (!video.paused) {
        video.pause();
        playButton.classList.remove("hidden");
      }
    });

    video.addEventListener("ended", () => {
      playButton.classList.remove("hidden");

      if (arrow) {
        arrow.classList.remove("hidden");
        arrowTimeout = setTimeout(() => {
          arrow.classList.add("hidden");
        }, 6000);
      }
    });

    video.addEventListener("play", () => {
      if (arrow) {
        arrow.classList.add("hidden");
        if (arrowTimeout) clearTimeout(arrowTimeout);
      }
    });

    // Volitelné: auto-play pozorování
    if (container.id === "auto-play-video-container") {
      const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            stopAllOtherVideos(video);
            video.play().then(() => {
              playButton.classList.add("hidden");
            }).catch(err => {
              console.warn("Video se nepodařilo automaticky přehrát:", err);
            });
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.5 });

      observer.observe(container);
    }
  });
});